'use strict';

/**
* Copyright (c) 2020 Copyright bp All Rights Reserved.
* Author: brian.li
* Date: 2020-09-01 10:38
* Desc: 
*/

import layout1 from './layout1.vue';
import layout2 from './layout2.vue';

export default {
  default: layout1,
  layout2
};